import _ from 'lodash';
import { createSelector } from 'reselect';

export const customerPreferencePreSelector = state => state.entities.customerPreferences;

export const selectCustomerPreferencesById = customerId => state =>
  state.entities.customerPreferences.toJS()[customerId];

// todo make the default preference selector spit out the site and sitegroup schemas in the format that we want.

// Format Schema to be [{'id':key, ...}, {'id':key, ...}] in order
export const customerPreferenceSelector = createSelector(customerPreferencePreSelector, preferences =>
  preferences.map(preference => {
    let siteSchema = _.map(preference.get('site_schema', {}), (value, key) => {
      value.id = key;
      value.order = _.has(value, 'order') ? value.order : 9999;
      return value;
    });
    siteSchema = _.sortBy(siteSchema, ['order']);

    let siteGroupSchema = _.map(preference.get('site_group_schema', {}), (value, key) => {
      value.id = key;
      value.order = _.has(value, 'order') ? value.order : 9999;
      return value;
    });
    siteGroupSchema = _.sortBy(siteGroupSchema, ['order']);
    preference = preference.set('site_schema', siteSchema);
    return preference.set('site_group_schema', siteGroupSchema);
  }),
);
